// @flow

import type { State } from '../reducers';
import {
  getConfiguratorSettings,
} from './main';

type GlobalState = {
  configuratorSettings: State,
};

type SaveConfig = $PropertyType<State, 'save_config'>;

export const getSaveConfigSettings = (state: GlobalState): SaveConfig => {
  const saveConfigSettings = getConfiguratorSettings(state).save_config;
  if (!saveConfigSettings) {
    throw new Error('Missing saveConfig settings in cartSettings store.');
  }
  return saveConfigSettings;
};

type Content = $PropertyType<SaveConfig, 'content'>;
export const getContent = (state: GlobalState): Content => getSaveConfigSettings(state).content;

type Title = $PropertyType<SaveConfig, 'title'>;
export const getTitle = (state: GlobalState): Title => getSaveConfigSettings(state).title;

export default null;
